import Feature from '@alltrails/shared/types/Feature';

export default function useFeatures(): Feature[] {
  return global.__AT_DATA__.features;
}
